import { render, staticRenderFns } from "./BadgeActionDelete.vue?vue&type=template&id=72801861&"
import script from "./BadgeActionDelete.vue?vue&type=script&lang=ts&"
export * from "./BadgeActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports